import styled from 'styled-components'

export const StyledSubLabel = styled.p`
	margin-bottom: 3px;
	${({ isVisible }) => isVisible ? '' : `visibility: hidden;`}
`

export const StyledNoMarginWrapper = styled.div`
	.inline {
		margin-bottom: 0;
	}
`
export const StyledPrintButton = styled.button`
	position: absolute;
	top: 15px;
	right: 15px;
	background-color: transparent;
`
